import AuthService from '@/services/AuthService';

export default {
  methods: {
    authLogin(email, password) {
      const { returnUrl } = this.$route.query;
      this.$store.dispatch('startLoadingPage');

      AuthService.loginUser(email, password)
        .then((result) => {
          const { success, message, user } = result;
          const variant = success ? 'success' : 'danger';
          // set notification message and styling
          const notifOptions = { message, show: 2, variant };
          this.$store.dispatch('setNotification', notifOptions);
          this.$store.dispatch('stopLoadingPage');

          if (success) {
            // set user object
            this.$store.dispatch('setUserData', user);

            const isFirstLogin = this.$get(this.$store, 'getters.firstLogin', false);
            if (isFirstLogin) {
              return this.$router.push({ name: 'user.password' });
            }

            // go to return path if provided
            if (returnUrl) {
              return this.$router.push({ path: returnUrl });
            }
            // reload page (home)
            return this.$router.push({ name: 'home' });
          }

          // do nothing
          return false;
        });
    },
  },
};
